import { useState } from 'react';
import { IResponseDataBody } from 'services/response';
import { IStaffItemData } from 'services/shop/types/staff';
import appointmentApis from '../services/apis';
import { bookingV2LoadingRef } from './Loading';
type IInquiryCustomerHandler = {
  onStart?: () => void;
  onDone?: (data: IStaffItemData[]) => void;
};
const useInquiryStaffList = (handler?: IInquiryCustomerHandler): [IStaffItemData[], (serviceIds: string[], startTime?: string, endTime?: string, date?: string) => Promise<void>] => {
  const [data, setData] = useState<IStaffItemData[]>([]);
  const fetch = async (serviceIds: string[], startTime?: string, endTime?: string, date?: string) => {
    bookingV2LoadingRef.current?.open();
    handler?.onStart?.();
    try {
      const res: IResponseDataBody<IStaffItemData[]> = await appointmentApis.listStaffByTime({
        serviceIds,
        endTime,
        startTime,
        date
      });
      const resData = res?.data?.data;
      if (resData) {
        const timeSlots = res.data.data;
        setData(timeSlots);
        handler?.onDone?.(timeSlots);
      } else {
        handler?.onDone?.([]);
        setData([]);
      }
    } catch (error) {
      handler?.onDone?.([]);
      setData([]);
    } finally {
      bookingV2LoadingRef.current?.close();
    }
  };

  return [data, fetch];
};

export default useInquiryStaffList;
